import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import HygineFormStructure from "../../components/hygiene-system/hygiene-form/HygineFormStructure";

const HygineForm = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HygineFormStructure
      userInfoData={userInfoData}
      mobileNumber={userInfoData?.mobile}
    />
  );
};

export default HygineForm;
